module.exports = __webpack_public_path__ + "img/background2 (2).f2224db4.jpg";